import useAgentAlertsPolling from '../../hooks/useAgentAlertsPolling';

function AgentAlertsManager() {
	useAgentAlertsPolling();
	return null;
}

export default AgentAlertsManager;
